import styled from "styled-components";
interface Props{
  percentage: number;
}
export const Content = styled.div<Props>`
  margin-top: 30px;
  padding: 18px;
  width: 100%;
  height: 157px;
  display: flex;
  align-items: center;
  border-radius: 8px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
  background-color: ${({ theme }) => theme.colors.secondary10};
  .loading {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .parcentage-info {
    position: relative;
    flex: 90%;
    display: flex;
    flex-direction: column;
    .title {
      font-weight: 600;
      color: ${({ theme }) => theme.colors.secondary100};
      font-size: 18px;
    }
    .text {
      color: ${({ theme }) => theme.colors.secondary70};
      font-size: 18px;
    }
    .percentage-bar {
      position: relative;
      width: 100%;
      margin-top: 14px;
      .total-bar {
        position: relative;
        border-radius: 8px;
        width: 100%;
        height: 22px;
        background-color: rgba(0, 191, 165, 0.5);
      }
      .active-bar {
        transition: all 0.9s;
        position: relative;
        border-radius: 8px;
        width: ${({ percentage }) => `${percentage}%`};
        height: 22px;
        background-color: ${({ theme }) => theme.colors.primary};
        z-index: 2;
        margin-top: -22px;
      }
    }
  }
  .percentage {
    flex: 10%;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.secondary100};
    font-size: 38px;
    margin-left: 20px;
  }
`;
